import React from 'react'

import './style.scss'

export function ModalWithFullSize({ isModalVisible, children }) {
    return isModalVisible ? <div className="full-size-modal">{children}</div> : null
}
